import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  h1 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    color: teal;
    margin: 20px;
  }
`;

export const Posts = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;
  height: 100vh;


  @media (min-width: 280px) {
    grid-template-columns: 1fr;
    grid-gap: 1.5rem;
    margin: 20px;
  }
  @media (min-width: 576px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    margin: 20px;
  }
  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 5rem;
    margin: 20px;
  }
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 5rem;
    margin: 20px;
  }
  @media (min-width: 1440px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5rem;
  }
`;
